import { State as AppState } from '..';
import { State } from './types';

export const selectStatus = (state: AppState): State => state.status;
